import * as tslib_1 from "tslib";
import { ODataFilterBuilder } from '@pages/generics/filter-builder/odata';
var RobotFilterBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(RobotFilterBuilder, _super);
    function RobotFilterBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RobotFilterBuilder.prototype.build = function (page, sort, searchFilters, filters, expand, select, mapper) {
        var options = _super.prototype.build.call(this, page, sort, searchFilters, filters, expand, select, mapper);
        if (options.orderBy &&
            options.orderBy[0] &&
            options.orderBy[0].startsWith(mapper.state.toString())) {
            var stateSort = options.orderBy[0].split(' ')[1];
            options.orderBy.unshift(mapper.isUnresponsive + ' ' + stateSort);
        }
        return options;
    };
    return RobotFilterBuilder;
}(ODataFilterBuilder));
export { RobotFilterBuilder };
